export function getAbbreviatedTimezone() {
  const guaranteedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const abbreviatedTimezone = Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName')?.value;

  return abbreviatedTimezone || guaranteedTimezone;
}
